import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";
import { ForgotPasswordRoute } from "../utils/Constant";

export const authRoutes = [
  // //Error
  {
    path: `/${ForgotPasswordRoute}`,
    Component: <ForgotPassword />,
  },
];
